"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAuctionBidOfferDtoSignatureStatusEnum = exports.UserAuctionBidOfferDtoStatusEnum = void 0;
exports.instanceOfUserAuctionBidOfferDto = instanceOfUserAuctionBidOfferDto;
exports.UserAuctionBidOfferDtoFromJSON = UserAuctionBidOfferDtoFromJSON;
exports.UserAuctionBidOfferDtoFromJSONTyped = UserAuctionBidOfferDtoFromJSONTyped;
exports.UserAuctionBidOfferDtoToJSON = UserAuctionBidOfferDtoToJSON;
exports.UserAuctionBidOfferDtoToJSONTyped = UserAuctionBidOfferDtoToJSONTyped;
/**
 * @export
 */
exports.UserAuctionBidOfferDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.UserAuctionBidOfferDtoSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * Check if a given object implements the UserAuctionBidOfferDto interface.
 */
function instanceOfUserAuctionBidOfferDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    return true;
}
function UserAuctionBidOfferDtoFromJSON(json) {
    return UserAuctionBidOfferDtoFromJSONTyped(json, false);
}
function UserAuctionBidOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
        'acceptedAt': json['acceptedAt'] == null ? undefined : json['acceptedAt'],
        'rejectedAt': json['rejectedAt'] == null ? undefined : json['rejectedAt'],
        'rejectedReason': json['rejectedReason'] == null ? undefined : json['rejectedReason'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'offerPrice': json['offerPrice'],
        'totalPaid': json['totalPaid'] == null ? undefined : json['totalPaid'],
    };
}
function UserAuctionBidOfferDtoToJSON(json) {
    return UserAuctionBidOfferDtoToJSONTyped(json, false);
}
function UserAuctionBidOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
        'acceptedAt': value['acceptedAt'],
        'rejectedAt': value['rejectedAt'],
        'rejectedReason': value['rejectedReason'],
        'settlementDate': value['settlementDate'],
        'depositAmount': value['depositAmount'],
        'offerPrice': value['offerPrice'],
        'totalPaid': value['totalPaid'],
    };
}
